/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var CookieHub = /** @class */ (function () {
        function CookieHub() {
        }
        CookieHub.check = function () {
            var _a;
            var ch = (_a = window['cookiehub'], (_a !== null && _a !== void 0 ? _a : null));
            if (ch === null) {
                return false;
            }
            // @ts-ignore
            return !!ch.hasConsented('analytics');
        };
        return CookieHub;
    }());

    exports.CookieHub = CookieHub;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
